export default __webpack_public_path__ + "static/media/Harbour-Light.779e0d7b.ttf";